// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___0Jli","badges":"styles_badges__1tbTT"};